export default __webpack_public_path__ + "media/images/features/saga/kino_hot_spring-91ff4bb63d72299571e9192480c26f0d.jpg";